import React, { useState, useEffect, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";
// import "./toggle-switch.css"

const EmailTemplateCard = ({
  id,
  title,
  description,
  sendTo,
  excluding,
  isActive,
  onToggleActive,
  onEdit,
  onClone,
  onRename,
  onDelete,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown

  // Handle outside clicks to close dropdown
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    // Add click event listener to document
    document.addEventListener("mousedown", handleOutsideClick);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <Card className="mb-3 rounded">
      <Card.Body className="p-4">
        <div className="d-flex flex-column flex-md-row justify-content-between email-template-card">
          <div className="mb-3 mb-md-0">
            <h5 className="mb-2">{title}</h5>
            <p className="text-muted mb-2">{description}</p>
            <div className="text-muted">
              <strong>Send to:</strong> {sendTo}
            </div>
            {excluding && (
              <div className="text-muted">
                <strong>Excluding:</strong> <em>{excluding}</em>
              </div>
            )}
          </div>

          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center mr-3">
              <div className="status-toggle-container mt-1">
                <label className="switch">
                  <input
                    type="checkbox"
                    className="lv-btn small-switch"
                    checked={isActive}
                    onChange={onToggleActive}
                    disabled={false}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <span className="ml-2">{isActive ? "Active" : "Inactive"}</span>
            </div>
            <div className="position-relative" ref={dropdownRef}>
              <Button
                variant="outline-secondary"
                className="d-flex align-items-center"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                Actions <FaChevronDown className="ml-2" />
              </Button>

              {showDropdown && (
                <div className="position-absolute dropdown-menu show emailcard-dropdown">
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      onEdit();
                      setShowDropdown(false);
                    }}
                  >
                    Edit Email
                  </button>
                  {/* <button
                    className="dropdown-item"
                    onClick={() => {
                      onClone();
                      setShowDropdown(false);
                    }}
                  >
                    Clone
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      onRename();
                      setShowDropdown(false);
                    }}
                  >
                    Rename
                  </button> */}
                  <button
                    className="dropdown-item text-danger"
                    onClick={() => {
                      onDelete();
                      setShowDropdown(false);
                    }}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default EmailTemplateCard;